import { AlertTriangle, Check, Clock, XCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';

type Tone = 'good' | 'warn' | 'bad' | 'new';

const TONES: Record<Tone, { className: string; icon: LucideIcon | null }> = {
  good: { className: 'text-good', icon: Check },
  warn: { className: 'text-warn', icon: Clock },
  bad: { className: 'text-bad', icon: XCircle },
  new: { className: 'border-olive bg-olive text-on-olive', icon: null },
};

/**
 * צבע סטטוס תמיד מגיע עם מילה או אייקון, אף פעם לא לבד (מערכת העיצוב).
 * לכן הטקסט הוא children חובה.
 */
export function StatusBadge({
  tone,
  icon,
  children,
  className,
}: {
  tone: Tone;
  icon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
}) {
  const preset = TONES[tone];
  const Icon = icon ?? preset.icon ?? AlertTriangle;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-pill border border-current px-2 py-1 text-label font-medium tracking-[0.02em]',
        preset.className,
        className,
      )}
    >
      {tone !== 'new' && <Icon size={14} strokeWidth={1.75} aria-hidden="true" />}
      {children}
    </span>
  );
}
